import { addAttachmentToHistory } from "../../api/historyService";

export const useAddAttachmentToHistory = (successCallback) => {
  const attach = async (id, data) => {
    try {
        const newRecord = await addAttachmentToHistory(id, data);
        if (successCallback) successCallback(newRecord);
        return newRecord;
    } catch (error) {
        console.error("Failed to attach file to history:", error);
        throw error;
    }
  };

  return { attach };
};